import { type AxiosResponse } from 'axios';

import { ordersAPI } from '~/services/api';
import { WEB_ORDERS_API } from '~/services/web-orders.service';

import {
  type RemoveOrdersTags,
  type RemoveOrdersTagsParams,
  type RemoveOrdersTagsResponseBody,
} from './remove-orders-tags.service.types';

/**
 * Removes the tags of multiple orders, the tags are appended to the orders existing tags.
 *
 * @param order_ids - The IDs of the orders to update.
 * @param tag_ids - The IDs of the tags to assign to the orders.
 * @return {Promise<AxiosResponse<RemoveOrdersTagsResponseBodyOrdersTagsResponseBody>>} Promise resolving to the updated orders.
 */
export const removeOrdersTags: RemoveOrdersTags = ({
  order_ids,
  tag_ids,
}: RemoveOrdersTagsParams): Promise<AxiosResponse<RemoveOrdersTagsResponseBody>> =>
  ordersAPI.request({
    data: {
      order_ids,
      tag_ids,
    },
    method: 'DELETE',
    url: `${WEB_ORDERS_API}/tags`,
  });
